import { render, staticRenderFns } from "./specials.vue?vue&type=template&id=5304803e&scoped=true"
import script from "./specials.vue?vue&type=script&lang=js"
export * from "./specials.vue?vue&type=script&lang=js"
import style0 from "./specials.vue?vue&type=style&index=0&id=5304803e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5304803e",
  null
  
)

export default component.exports